import { useState, useEffect } from 'react'

export const useResponsive = () => {
    const [isMobile, setIsMobile] = useState(false)
    const [isTablet, setIsTablet] = useState(false)
    const [hasTouch, setHasTouch] = useState(false)

    useEffect(() => {
        // 使用 matchMedia API
        const mobileQuery = window.matchMedia('(max-width: 768px)')
        const tabletQuery = window.matchMedia('(max-width: 1024px)')

        // 触摸能力检测
        const touchCapable = 'ontouchstart' in window || navigator.maxTouchPoints > 0

        const handleMobileChange = (e) => setIsMobile(e.matches)
        const handleTabletChange = (e) => setIsTablet(e.matches)

        // 初始化
        setIsMobile(mobileQuery.matches)
        setIsTablet(tabletQuery.matches)
        setHasTouch(touchCapable)

        // 监听变化
        mobileQuery.addListener(handleMobileChange)
        tabletQuery.addListener(handleTabletChange)

        return () => {
            mobileQuery.removeListener(handleMobileChange)
            tabletQuery.removeListener(handleTabletChange)
        }
    }, [])

    return { isMobile, isTablet, hasTouch }
}